
    <div class="d-flex d-flex-gap align-items-center pl-2">
      <div class="bg-indent"></div>
      <ng-content></ng-content>
    </div>
  